import React, { memo } from 'react';
import { Box, Typography, CircularProgress, Icon } from '@material-ui/core';

import useStyles from './styles';

const Sending = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Typography className="sending-title" variant="h6">
        Enviando agendamento...
      </Typography>
      <Icon className="sending-icon" color="inherit">
        event
      </Icon>
      <Typography className="sending-message" variant="body2">
        Aguarde enquanto salvamos as informações do seu agendamento.
      </Typography>
      <CircularProgress className="sending-progress" size={52} />
    </Box>
  );
};

export default memo(Sending);
